
import { NgModule } from '@angular/core';

import { FinancialClosingEditProvider } from './financial-closing-edit.provider';
import { FinancialClosingListProvider } from './financial-closing-list.provider';

export * from './financial-closing-edit.provider';
export * from './financial-closing-list.provider';

export {
  FinancialClosingListProvider,
  FinancialClosingEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    FinancialClosingEditProvider,
    FinancialClosingListProvider
  ]
})
export class FinancialClosingBackendModule { }
